import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FloorRateIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 21H21M12 3V17M12 17L7 12M12 17L17 12"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

FloorRateIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FloorRateIcon);
